export default "__VITE_ASSET__bOvhLGHl__ 1200w";